module.exports = __webpack_public_path__ + "static/media/pinamar.2d7f6042.webp";